import axios, { AxiosResponse } from 'axios';
import useUser from './useUser';

import { URL_WAREHOUSE_IM } from 'constants/url';
import useCustomSnackbar from 'hooks/useCustomSnackbar';
import { IWareHouseList } from 'interfaces/imWarehouse.interface';

export default function useWarehouseIM() {
  const { jwt } = useUser();
  const { showNotistack } = useCustomSnackbar();

  const headers = {
    Authorization: `Bearer ${jwt}`
  };

  const getWarehouses = (): Promise<IWareHouseList[]> => {
    return axios
      .get(URL_WAREHOUSE_IM, { headers })
      .then((result: AxiosResponse) => {
        return result.data;
      })
      .catch(() => {
        showNotistack({ message: 'Ocurrió un error, por favor comuniquese con el administrador' });
      });
  };

  const getWarehouseById = (wareHouseId: string): Promise<IWareHouseList> => {
    return axios
      .get(`${URL_WAREHOUSE_IM}/${wareHouseId}`, { headers })
      .then((result: AxiosResponse) => {
        if (result.status === 200) {
          return result.data;
        } else {
          return null;
        }
      })
      .catch(() => {
        showNotistack({ message: 'Ocurrió un error, por favor comuniquese con el administrador' });
      });
  };

  const addWarehouse = (data: any): Promise<boolean> => {
    return axios.post(URL_WAREHOUSE_IM, data, { headers }).then((response: AxiosResponse) => {
      return response.status === 201;
    });
  };

  const updateWarehouse = (data: any): Promise<boolean> => {
    if (!data.id) throw new Error('El campo id es obligatorio');
    return axios.put(`${URL_WAREHOUSE_IM}/${data.id}`, data, { headers }).then((response: AxiosResponse) => {
      return response.status === 200;
    });
  };

  const deleteWarehouse = (warehouseId: string): Promise<boolean> => {
    if (!warehouseId) throw new Error('El campo id es obligatorio');
    return axios.delete(`${URL_WAREHOUSE_IM}/${warehouseId}`, { headers }).then((response: AxiosResponse) => {
      return response.status === 204;
    });
  };

  return {
    getWarehouses,
    getWarehouseById,
    addWarehouse,
    updateWarehouse,
    deleteWarehouse
  };
}
